import { render } from "./WaveAnimation.vue?vue&type=template&id=61a33324"
import script from "./WaveAnimation.vue?vue&type=script&lang=js"
export * from "./WaveAnimation.vue?vue&type=script&lang=js"

import exportComponent from "/home/vitsuji/Projects/iGEM-Wiki/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__